import { combineReducers } from 'redux';
import appReducer from './app/pickYourRoom.reducer';
import mapReducer from './map/map.reducer';

const pickYourRoom = combineReducers({
  app: appReducer,
  mapper: mapReducer,
});

export default pickYourRoom;
